'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaAccommodations = function () {
  function WinresOmalomaAccommodations($rootScope, $scope, omalomaService) {
    var _this = this;

    _classCallCheck(this, WinresOmalomaAccommodations);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.omalomaService = omalomaService;

    this.setStatus('init', null);

    $scope.$watch(function () {
      return _this.bookingNumber;
    }, function () {
      return _this.update();
    });
  }

  _createClass(WinresOmalomaAccommodations, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.$rootScope.$on('login', function () {
        return _this2.update();
      });
      this.$rootScope.$on('logout', function () {
        return _this2.setStatus('out', null);
      });
      this.$scope.$watch(function () {
        return _this2.bookingNumber;
      }, function () {
        return _this2.update();
      });
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.update();
      } else {
        this.setStatus('out', null);
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$scope.lines = [];
    }
  }, {
    key: 'update',
    value: function update() {
      var _this3 = this;

      if (!this.bookingNumber) {
        console.log('[WOA] Booking number not available yet.');
        this.setStatus('waiting_for_parameter', null);
        this.reset();
        return;
      }

      this.omalomaService.getAccommodations(this.bookingNumber).then(function (lines) {
        var groups = _.groupBy(lines, function (line) {
          return line.BeginDate;
        });

        // Sort groups by date
        var ordered = {};
        _(groups).keys().sort().each(function (key) {
          ordered[key] = groups[key];
        });
        groups = ordered;

        var sorted = [];
        _.each(groups, function (group) {
          // Sort group products by name
          sorted.push(_.orderBy(group, function (g) {
            return g.DestinationInfo.ProductName;
          }, ["asc"]));
        });

        lines = _.flatten(sorted);

        console.log('[WOA] Got product lines for accommodations:', lines);
        _this3.$scope.lines = lines;
        _this3.setStatus('ready', null);
      }).catch(function (error) {
        console.error('[WOA] Failed to get accommodations for', _this3.bookingNumber, ':', error);
        _this3.reset();
        _this3.setStatus('error', 'malfunction');
      });
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, error) {
      this.$scope.status = status;
      console.log('[WODI] Set status to', status);
      if (error !== undefined) {
        if (error) {
          console.log('[WODI] Error:', error);
          this.$scope.error = error;
        }
      }
    }
  }]);

  return WinresOmalomaAccommodations;
}();

WinresOmalomaAccommodations.$inject = ['$rootScope', '$scope', 'omalomaService'];

_module3.default.component('winresOmalomaAccommodations', {
  template: require('./winresOmalomaAccommodations.html'),
  controller: WinresOmalomaAccommodations,
  bindings: {
    bookingNumber: '<'
  },
  require: {}
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaAccommodations/winresOmalomaAccommodations.js
// module id = 319
// module chunks = 2